/* THEORIC - Ajustes globais de acessibilidade em conteudo gerado depois do carregamento
   (apps, video_tag da Shopify, componentes que montam HTML por JS).
   - <img> de fallback dentro de <video> sem alt: vira decorativa (alt="").
     O video ja e descrito pelo controle/rotulo ao redor.
   - <iframe> sem title: recebe um titulo pelo tipo de conteudo.
   - Links que abrem em nova aba: rel="noopener" e aviso para leitor de tela.
   Roda de novo quando o DOM muda (MutationObserver com debounce). */
(function () {
  if (window.__theoricA11y) return;
  window.__theoricA11y = true;

  function iframeTitle(src) {
    if (/youtube|vimeo|video/i.test(src)) return 'Vídeo incorporado';
    if (/maps|mapbox/i.test(src)) return 'Mapa';
    if (/judge\.me|reviews/i.test(src)) return 'Avaliações de clientes';
    return 'Conteúdo incorporado';
  }

  function fix(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('video img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });

    scope.querySelectorAll('iframe:not([title])').forEach(function (f) {
      f.setAttribute('title', iframeTitle(f.getAttribute('src') || ''));
    });

    scope.querySelectorAll('a[target="_blank"]:not([data-a11y-nt])').forEach(function (a) {
      a.setAttribute('data-a11y-nt', '');
      var rel = (a.getAttribute('rel') || '').split(/\s+/);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      a.setAttribute('rel', rel.join(' ').trim());
      if (!/nova aba/i.test(a.textContent + (a.getAttribute('aria-label') || ''))) {
        var hint = document.createElement('span');
        hint.className = 'visually-hidden';
        hint.textContent = ' (abre em nova aba)';
        if (a.hasAttribute('aria-label')) a.setAttribute('aria-label', a.getAttribute('aria-label') + ' (abre em nova aba)');
        else a.appendChild(hint);
      }
    });
  }

  function start() {
    fix(document);
    if (!('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { fix(document); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
